(function () {
  'use strict';


  function ensureTrendyFavorites() {
    if (window.TrendyFavorites && window.TrendyFavorites.version === '1.0.0') {
      return window.TrendyFavorites;
    }

    var storageKey = 'trendy:favorite-items:v1';
    var memoryFavorites = [];

    function normalizeHandle(value) {
      return String(value || '').trim();
    }

    function uniqueHandles(values) {
      var seen = {};
      return (Array.isArray(values) ? values : []).map(normalizeHandle).filter(function (handle) {
        if (!handle || seen[handle]) return false;
        seen[handle] = true;
        return true;
      });
    }

    function readFavorites() {
      try {
        var raw = window.localStorage.getItem(storageKey);
        if (!raw) return memoryFavorites.slice();
        var parsed = JSON.parse(raw);
        memoryFavorites = uniqueHandles(parsed);
        return memoryFavorites.slice();
      } catch (error) {
        return memoryFavorites.slice();
      }
    }

    function updateButton(button, favorites) {
      if (!button) return;
      var handle = normalizeHandle(button.dataset.productHandle);
      var title = button.dataset.productTitle || 'this item';
      var active = Boolean(handle && favorites.indexOf(handle) !== -1);

      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute(
        'aria-label',
        active ? ('Remove ' + title + ' from Favorite Items') : ('Add ' + title + ' to Favorite Items')
      );
      button.setAttribute('title', active ? 'Remove from Favorite Items' : 'Add to Favorite Items');
    }

    function refresh(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var favorites = readFavorites();
      scope.querySelectorAll('[data-trendy-favorite-button]').forEach(function (button) {
        updateButton(button, favorites);
      });
      return favorites;
    }

    function emitChange(detail) {
      var payload = detail || {};
      payload.handles = readFavorites();
      payload.count = payload.handles.length;
      document.dispatchEvent(new CustomEvent('trendy:favorites:change', { detail: payload }));
      window.dispatchEvent(new CustomEvent('trendy:favorites:change', { detail: payload }));
    }

    function saveFavorites(values, detail) {
      memoryFavorites = uniqueHandles(values);
      try {
        window.localStorage.setItem(storageKey, JSON.stringify(memoryFavorites));
      } catch (error) {
      }
      refresh(document);
      emitChange(detail);
      return memoryFavorites.slice();
    }

    function has(handle) {
      var normalized = normalizeHandle(handle);
      return normalized ? readFavorites().indexOf(normalized) !== -1 : false;
    }

    function add(handle) {
      var normalized = normalizeHandle(handle);
      if (!normalized) return readFavorites();
      var favorites = readFavorites();
      if (favorites.indexOf(normalized) === -1) favorites.unshift(normalized);
      return saveFavorites(favorites, { handle: normalized, active: true });
    }

    function remove(handle) {
      var normalized = normalizeHandle(handle);
      if (!normalized) return readFavorites();
      var favorites = readFavorites().filter(function (item) { return item !== normalized; });
      return saveFavorites(favorites, { handle: normalized, active: false });
    }

    function toggle(handle) {
      return has(handle) ? remove(handle) : add(handle);
    }

    var api = {
      version: '1.0.0',
      storageKey: storageKey,
      get: readFavorites,
      count: function () { return readFavorites().length; },
      has: has,
      add: add,
      remove: remove,
      toggle: toggle,
      clear: function () { return saveFavorites([], { handle: '', active: false, cleared: true }); },
      refresh: refresh
    };

    window.TrendyFavorites = api;

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      var button = target.closest('[data-trendy-favorite-button]');
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();
      api.toggle(button.dataset.productHandle || '');
    });

    document.addEventListener('shopify:section:load', function (event) {
      api.refresh(event.target);
    });

    window.addEventListener('storage', function (event) {
      if (event.key !== storageKey) return;
      api.refresh(document);
      emitChange({ external: true });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { api.refresh(document); }, { once: true });
    } else {
      api.refresh(document);
    }

    return api;
  }

  var trendyFavorites = ensureTrendyFavorites();

  function normalize(value) {
    return String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
  }

  function rootUrl(section) {
    var value = section.dataset.rootUrl || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return value.endsWith('/') ? value : value + '/';
  }

  function cardParts(card) {
    return {
      form: card.querySelector('[data-pfg-form]'),
      select: card.querySelector('[data-pfg-variant-select]'),
      input: card.querySelector('[data-pfg-variant-input]'),
      button: card.querySelector('[data-pfg-add-button]'),
      buttonText: card.querySelector('[data-pfg-button-text]'),
      price: card.querySelector('[data-pfg-price]'),
      compare: card.querySelector('[data-pfg-compare-price]'),
      saleBadge: card.querySelector('[data-pfg-sale-badge]'),
      image: card.querySelector('.trendy-filter-grid-v2__image'),
      message: card.querySelector('[data-pfg-message]')
    };
  }

  function selectedOption(parts) {
    return parts.select ? parts.select.options[parts.select.selectedIndex] : null;
  }

  function variantId(parts) {
    if (parts.select) return parts.select.value;
    return parts.input ? parts.input.value : '';
  }

  function setMessage(parts, text, isError) {
    if (!parts.message) return;
    parts.message.textContent = text || '';
    parts.message.classList.toggle('is-error', Boolean(isError));
  }

  function setButton(parts, available) {
    if (!parts.button) return;
    parts.button.disabled = !available;
    if (parts.buttonText) {
      parts.buttonText.textContent = available
        ? (parts.button.dataset.defaultText || 'ADD TO CART')
        : (parts.button.dataset.soldOutText || 'SOLD OUT');
    }
  }

  function updateVariant(card) {
    var parts = cardParts(card);
    var option = selectedOption(parts);
    if (!option) return;

    var available = option.dataset.available !== 'false';
    var onSale = option.dataset.onSale === 'true';

    if (parts.price && option.dataset.price) parts.price.textContent = option.dataset.price;

    if (parts.compare) {
      parts.compare.textContent = onSale ? (option.dataset.comparePrice || '') : '';
      parts.compare.classList.toggle('is-hidden', !onSale);
    }

    if (parts.saleBadge) parts.saleBadge.classList.toggle('is-hidden', !onSale);

    if (parts.image && option.dataset.image) {
      parts.image.src = option.dataset.image;
      parts.image.removeAttribute('srcset');
      parts.image.removeAttribute('sizes');
      parts.image.alt = option.dataset.imageAlt || parts.image.alt || '';
    }

    setButton(parts, available);
    setMessage(parts, '', false);
  }

  async function fallbackAdd(section, id) {
    var response = await fetch(rootUrl(section) + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    });

    var data = await response.json().catch(function () { return {}; });
    if (!response.ok) throw new Error(data.description || data.message || 'Unable to add this product.');

    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: data }));
    window.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));

    if (section.dataset.openCartAfterAdd === 'true') {
      if (window.TrendyCart && typeof window.TrendyCart.refresh === 'function') await window.TrendyCart.refresh();
      if (window.TrendyCart && typeof window.TrendyCart.open === 'function') await window.TrendyCart.open();
    }

    return data;
  }

  async function addToCart(section, id) {
    if (section.dataset.openCartAfterAdd === 'true' && window.TrendyCart && typeof window.TrendyCart.add === 'function') {
      return window.TrendyCart.add(id, 1, {});
    }
    return fallbackAdd(section, id);
  }

  function initCard(section, card) {
    if (!card || card.dataset.pfgReady === 'true') return;
    card.dataset.pfgReady = 'true';

    var parts = cardParts(card);
    if (!parts.form || !parts.button) return;

    if (parts.select) parts.select.addEventListener('change', function () { updateVariant(card); });

    parts.form.addEventListener('submit', async function (event) {
      event.preventDefault();
      event.stopPropagation();

      var id = variantId(parts);
      if (!id || parts.button.disabled || parts.button.dataset.busy === 'true') return;

      parts.button.dataset.busy = 'true';
      parts.button.disabled = true;
      parts.button.classList.remove('is-added', 'is-error');
      parts.button.classList.add('is-loading');
      setMessage(parts, '', false);
      if (parts.buttonText) parts.buttonText.textContent = parts.button.dataset.loadingText || 'ADDING...';

      try {
        await addToCart(section, id);
        parts.button.classList.remove('is-loading');
        parts.button.classList.add('is-added');
        if (parts.buttonText) parts.buttonText.textContent = parts.button.dataset.addedText || 'ADDED';

        window.setTimeout(function () {
          parts.button.classList.remove('is-added');
          parts.button.dataset.busy = 'false';
          if (parts.select) updateVariant(card);
          else setButton(parts, true);
        }, 1000);
      } catch (error) {
        parts.button.classList.remove('is-loading');
        parts.button.classList.add('is-error');
        parts.button.dataset.busy = 'false';
        parts.button.disabled = false;
        if (parts.buttonText) parts.buttonText.textContent = parts.button.dataset.errorText || 'TRY AGAIN';
        setMessage(parts, error && error.message ? error.message : 'Unable to add this product.', true);

        window.setTimeout(function () {
          parts.button.classList.remove('is-error');
          if (parts.select) updateVariant(card);
          else setButton(parts, true);
        }, 1800);
      }
    });

    if (parts.select) updateVariant(card);
  }

  function createCheckRow(key, value, count) {
    var label = document.createElement('label');
    label.className = 'trendy-filter-grid-v2__check-row';

    var input = document.createElement('input');
    input.type = 'checkbox';
    input.value = value;
    input.dataset.pfgCheckbox = '';
    input.dataset.filterKey = key;

    var fake = document.createElement('span');
    fake.className = 'trendy-filter-grid-v2__fake-check';

    var text = document.createElement('span');
    text.className = 'trendy-filter-grid-v2__check-label';
    text.textContent = value;

    var countEl = document.createElement('span');
    countEl.className = 'trendy-filter-grid-v2__check-count';
    countEl.textContent = String(count);

    label.append(input, fake, text, countEl);
    return label;
  }

  function addCount(map, key) {
    var clean = String(key || '').trim();
    if (!clean) return;
    map.set(clean, (map.get(clean) || 0) + 1);
  }

  function sortedEntries(map, preferred) {
    var entries = Array.from(map.entries());
    if (preferred && preferred.length) {
      entries.sort(function (a, b) {
        var ai = preferred.indexOf(a[0]);
        var bi = preferred.indexOf(b[0]);
        if (ai === -1) ai = 999;
        if (bi === -1) bi = 999;
        if (ai !== bi) return ai - bi;
        return a[0].localeCompare(b[0]);
      });
    } else {
      entries.sort(function (a, b) { return a[0].localeCompare(b[0]); });
    }
    return entries;
  }

  function buildFilters(section, cards) {
    var maps = {
      category: new Map(),
      subcategory: new Map(),
      productType: new Map(),
      brand: new Map()
    };
    var optionMaps = new Map();

    cards.forEach(function (card) {
      addCount(maps.category, card.dataset.category);
      addCount(maps.subcategory, card.dataset.subcategory);
      addCount(maps.productType, card.dataset.productType);
      addCount(maps.brand, card.dataset.brand);

      var seenOnCard = new Set();
      card.querySelectorAll('[data-pfg-option]').forEach(function (meta) {
        var name = String(meta.dataset.optionName || '').trim();
        var value = String(meta.dataset.optionValue || '').trim();
        if (!name || !value || normalize(name) === 'title') return;
        var pair = normalize(name) + '||' + normalize(value);
        if (seenOnCard.has(pair)) return;
        seenOnCard.add(pair);
        if (!optionMaps.has(name)) optionMaps.set(name, new Map());
        addCount(optionMaps.get(name), value);
      });
    });

    var preferred = {
      category: ['Makeup', 'Skincare', 'Bath & Body', 'Accessories'],
      subcategory: ['Face', 'Eyes & Brows', 'Lips', 'Cleansers & Removers', 'Body Scrubs', 'Bags & Pouches', 'Other Makeup'],
      productType: ['Concealer', 'Mascara', 'Powder', 'Foundation', 'Liner', 'Brow Gel', 'Lipstick', 'Lip Gloss', 'Micellar Water', 'Body Scrub', 'Waist Pouch', 'Makeup Bag', 'Beauty Product']
    };

    Object.keys(maps).forEach(function (key) {
      var target = section.querySelector('[data-pfg-filter-values="' + key + '"]');
      if (!target) return;
      target.innerHTML = '';
      sortedEntries(maps[key], preferred[key]).forEach(function (entry) {
        target.appendChild(createCheckRow(key, entry[0], entry[1]));
      });
      var group = target.closest('.trendy-filter-grid-v2__filter-group');
      if (group) group.hidden = maps[key].size <= 1;
    });

    var dynamicRoot = section.querySelector('[data-pfg-dynamic-options]');
    if (dynamicRoot) {
      dynamicRoot.innerHTML = '';
      Array.from(optionMaps.entries()).sort(function (a, b) { return a[0].localeCompare(b[0]); }).forEach(function (entry) {
        var optionName = entry[0];
        var values = entry[1];
        if (values.size <= 1) return;

        var wrapper = document.createElement('div');
        wrapper.className = 'trendy-filter-grid-v2__dynamic-group';

        var toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'trendy-filter-grid-v2__filter-heading';
        toggle.setAttribute('aria-expanded', 'false');
        toggle.dataset.pfgGroupToggle = '';
        toggle.innerHTML = '<span>' + escapeHtml(optionName) + '</span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m7 10 5 5 5-5"></path></svg>';

        var panel = document.createElement('div');
        panel.className = 'trendy-filter-grid-v2__filter-panel is-collapsed';
        sortedEntries(values).forEach(function (valueEntry) {
          panel.appendChild(createCheckRow('option:' + optionName, valueEntry[0], valueEntry[1]));
        });

        wrapper.append(toggle, panel);
        dynamicRoot.appendChild(wrapper);
      });
    }
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>'"]/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#039;', '"': '&quot;' })[char];
    });
  }

  function selectedValues(section, key) {
    return Array.from(section.querySelectorAll('[data-pfg-checkbox][data-filter-key="' + CSS.escape(key) + '"]:checked')).map(function (input) {
      return normalize(input.value);
    });
  }

  function cardOptionValues(card, optionName) {
    var target = normalize(optionName);
    return Array.from(card.querySelectorAll('[data-pfg-option]')).filter(function (meta) {
      return normalize(meta.dataset.optionName) === target;
    }).map(function (meta) {
      return normalize(meta.dataset.optionValue);
    });
  }

  function hasIntersection(a, b) {
    return a.some(function (value) { return b.indexOf(value) !== -1; });
  }

  function currentState(section) {
    var dynamicKeys = Array.from(new Set(Array.from(section.querySelectorAll('[data-pfg-checkbox]')).map(function (input) {
      return input.dataset.filterKey || '';
    }).filter(function (key) { return key.indexOf('option:') === 0; })));

    var dynamic = {};
    dynamicKeys.forEach(function (key) {
      var values = selectedValues(section, key);
      if (values.length) dynamic[key.slice(7)] = values;
    });

    var minInput = section.querySelector('[data-pfg-price-min]');
    var maxInput = section.querySelector('[data-pfg-price-max]');
    var rawMin = minInput ? minInput.value.trim() : '';
    var rawMax = maxInput ? maxInput.value.trim() : '';

    return {
      search: normalize(section.querySelector('[data-pfg-search]')?.value || ''),
      category: selectedValues(section, 'category'),
      subcategory: selectedValues(section, 'subcategory'),
      productType: selectedValues(section, 'productType'),
      brand: selectedValues(section, 'brand'),
      availability: selectedValues(section, 'availability'),
      offer: selectedValues(section, 'offer'),
      setup: selectedValues(section, 'setup'),
      options: dynamic,
      minPrice: rawMin === '' ? null : Math.max(0, Number(rawMin) * 100),
      maxPrice: rawMax === '' ? null : Math.max(0, Number(rawMax) * 100)
    };
  }

  function matchesList(value, selected) {
    if (!selected.length) return true;
    return selected.indexOf(normalize(value)) !== -1;
  }

  function matchesCard(card, state) {
    if (state.search) {
      var searchHaystack = normalize(card.dataset.search + ' ' + Array.from(card.querySelectorAll('[data-pfg-option]')).map(function (meta) {
        return (meta.dataset.optionName || '') + ' ' + (meta.dataset.optionValue || '');
      }).join(' '));
      var terms = state.search.split(' ').filter(Boolean);
      if (!terms.every(function (term) { return searchHaystack.indexOf(term) !== -1; })) return false;
    }

    if (!matchesList(card.dataset.category, state.category)) return false;
    if (!matchesList(card.dataset.subcategory, state.subcategory)) return false;
    if (!matchesList(card.dataset.productType, state.productType)) return false;
    if (!matchesList(card.dataset.brand, state.brand)) return false;

    var availableValue = card.dataset.available === 'true' ? 'in-stock' : 'sold-out';
    if (state.availability.length && state.availability.indexOf(availableValue) === -1) return false;

    var offerValue = card.dataset.sale === 'true' ? 'sale' : 'regular';
    if (state.offer.length && state.offer.indexOf(offerValue) === -1) return false;

    var setupValue = card.dataset.hasOptions === 'true' ? 'has-options' : 'single-option';
    if (state.setup.length && state.setup.indexOf(setupValue) === -1) return false;

    var priceMin = Number(card.dataset.priceMin || 0);
    var priceMax = Number(card.dataset.priceMax || priceMin);
    if (state.minPrice !== null && priceMax < state.minPrice) return false;
    if (state.maxPrice !== null && priceMin > state.maxPrice) return false;

    var optionNames = Object.keys(state.options);
    for (var i = 0; i < optionNames.length; i += 1) {
      var optionName = optionNames[i];
      var cardValues = cardOptionValues(card, optionName);
      if (!hasIntersection(cardValues, state.options[optionName])) return false;
    }

    return true;
  }

  function sortCards(section, cards) {
    var grid = section.querySelector('[data-pfg-grid]');
    var sort = section.querySelector('[data-pfg-sort]')?.value || 'featured';
    if (!grid) return;

    var sorted = cards.slice().sort(function (a, b) {
      var aTitle = normalize(a.dataset.title);
      var bTitle = normalize(b.dataset.title);
      var aBrand = normalize(a.dataset.brand);
      var bBrand = normalize(b.dataset.brand);
      var aPrice = Number(a.dataset.priceMin || 0);
      var bPrice = Number(b.dataset.priceMin || 0);
      var aSale = a.dataset.sale === 'true' ? 1 : 0;
      var bSale = b.dataset.sale === 'true' ? 1 : 0;
      var aStock = a.dataset.available === 'true' ? 1 : 0;
      var bStock = b.dataset.available === 'true' ? 1 : 0;

      if (sort === 'price-asc') return aPrice - bPrice;
      if (sort === 'price-desc') return bPrice - aPrice;
      if (sort === 'title-asc') return aTitle.localeCompare(bTitle);
      if (sort === 'title-desc') return bTitle.localeCompare(aTitle);
      if (sort === 'brand-asc') return aBrand.localeCompare(bBrand) || aTitle.localeCompare(bTitle);
      if (sort === 'sale-first') return bSale - aSale || Number(a.dataset.originalIndex) - Number(b.dataset.originalIndex);
      if (sort === 'stock-first') return bStock - aStock || Number(a.dataset.originalIndex) - Number(b.dataset.originalIndex);
      return Number(a.dataset.originalIndex) - Number(b.dataset.originalIndex);
    });

    sorted.forEach(function (card) { grid.appendChild(card); });
  }

  function activeCount(state) {
    var total = state.category.length + state.subcategory.length + state.productType.length + state.brand.length + state.availability.length + state.offer.length + state.setup.length;
    Object.keys(state.options).forEach(function (key) { total += state.options[key].length; });
    if (state.search) total += 1;
    if (state.minPrice !== null || state.maxPrice !== null) total += 1;
    return total;
  }

  function chipLabel(key, value) {
    if (key.indexOf('option:') === 0) return key.slice(7) + ': ' + value;
    var labels = {
      category: 'Category',
      subcategory: 'Area',
      productType: 'Type',
      brand: 'Brand',
      availability: 'Stock',
      offer: 'Offer',
      setup: 'Options'
    };
    return (labels[key] || key) + ': ' + value;
  }

  function renderActiveChips(section, state) {
    var wrap = section.querySelector('[data-pfg-active-filters]');
    var chips = section.querySelector('[data-pfg-active-chips]');
    if (!wrap || !chips) return;
    chips.innerHTML = '';

    Array.from(section.querySelectorAll('[data-pfg-checkbox]:checked')).forEach(function (input) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'trendy-filter-grid-v2__active-chip';
      button.dataset.removeFilterKey = input.dataset.filterKey || '';
      button.dataset.removeFilterValue = input.value;
      button.innerHTML = '<span>' + escapeHtml(chipLabel(input.dataset.filterKey || '', input.value)) + '</span><span aria-hidden="true">×</span>';
      chips.appendChild(button);
    });

    if (state.search) {
      var searchChip = document.createElement('button');
      searchChip.type = 'button';
      searchChip.className = 'trendy-filter-grid-v2__active-chip';
      searchChip.dataset.removeSearch = 'true';
      searchChip.innerHTML = '<span>Search: ' + escapeHtml(state.search) + '</span><span aria-hidden="true">×</span>';
      chips.appendChild(searchChip);
    }

    if (state.minPrice !== null || state.maxPrice !== null) {
      var priceChip = document.createElement('button');
      priceChip.type = 'button';
      priceChip.className = 'trendy-filter-grid-v2__active-chip';
      priceChip.dataset.removePrice = 'true';
      var minText = state.minPrice === null ? '$0' : '$' + (state.minPrice / 100).toFixed(2).replace(/\.00$/, '');
      var maxText = state.maxPrice === null ? 'Any' : '$' + (state.maxPrice / 100).toFixed(2).replace(/\.00$/, '');
      priceChip.innerHTML = '<span>Price: ' + minText + '–' + maxText + '</span><span aria-hidden="true">×</span>';
      chips.appendChild(priceChip);
    }

    wrap.hidden = chips.children.length === 0;
  }

  function updatePresetState(section) {
    var min = section.querySelector('[data-pfg-price-min]')?.value.trim() || '';
    var max = section.querySelector('[data-pfg-price-max]')?.value.trim() || '';
    section.querySelectorAll('[data-pfg-price-preset]').forEach(function (button) {
      button.classList.toggle('is-active', button.dataset.min === min && button.dataset.max === max);
    });
  }

  function applyFilters(section, cards) {
    var state = currentState(section);
    sortCards(section, cards);

    var visible = 0;
    cards.forEach(function (card) {
      var show = matchesCard(card, state);
      card.hidden = !show;
      if (show) visible += 1;
    });

    var total = cards.length;
    var countText = section.querySelector('[data-pfg-results-count]');
    if (countText) countText.textContent = visible + ' of ' + total + ' products';

    var mobileCount = section.querySelector('[data-pfg-mobile-results]');
    if (mobileCount) mobileCount.textContent = String(visible);

    var noResults = section.querySelector('[data-pfg-no-results]');
    if (noResults) noResults.hidden = visible !== 0;

    var filterCount = section.querySelector('[data-pfg-filter-count]');
    var count = activeCount(state);
    if (filterCount) {
      filterCount.textContent = String(count);
      filterCount.hidden = count === 0;
    }

    var searchClear = section.querySelector('[data-pfg-search-clear]');
    if (searchClear) searchClear.hidden = !state.search;

    renderActiveChips(section, state);
    updatePresetState(section);
  }

  function clearAll(section) {
    section.querySelectorAll('[data-pfg-checkbox]:checked').forEach(function (input) { input.checked = false; });
    var search = section.querySelector('[data-pfg-search]');
    var min = section.querySelector('[data-pfg-price-min]');
    var max = section.querySelector('[data-pfg-price-max]');
    if (search) search.value = '';
    if (min) min.value = '';
    if (max) max.value = '';
  }

  function setFiltersOpen(section, open) {
    var filters = section.querySelector('[data-pfg-filters]');
    var overlay = section.querySelector('[data-pfg-overlay]');
    var openButton = section.querySelector('[data-pfg-filter-open]');
    if (!filters || !overlay) return;

    filters.classList.toggle('is-open', open);
    overlay.classList.toggle('is-active', open);
    openButton?.setAttribute('aria-expanded', open ? 'true' : 'false');

    if (window.matchMedia('(max-width: 989px)').matches) {
      document.body.style.overflow = open ? 'hidden' : '';
    }
  }

  function initGrid(section) {
    trendyFavorites.refresh(section);
    if (!section || section.dataset.pfgSectionReady === 'true') return;
    section.dataset.pfgSectionReady = 'true';

    var cards = Array.from(section.querySelectorAll('[data-pfg-card]'));
    if (!cards.length) return;

    cards.forEach(function (card) { initCard(section, card); });
    buildFilters(section, cards);

    var minProductPrice = Math.min.apply(null, cards.map(function (card) { return Number(card.dataset.priceMin || 0); }));
    var maxProductPrice = Math.max.apply(null, cards.map(function (card) { return Number(card.dataset.priceMax || 0); }));
    var minInput = section.querySelector('[data-pfg-price-min]');
    var maxInput = section.querySelector('[data-pfg-price-max]');
    if (minInput && Number.isFinite(minProductPrice)) minInput.placeholder = String(Math.floor(minProductPrice / 100));
    if (maxInput && Number.isFinite(maxProductPrice)) maxInput.placeholder = String(Math.ceil(maxProductPrice / 100));

    section.addEventListener('change', function (event) {
      if (event.target.matches('[data-pfg-checkbox], [data-pfg-price-min], [data-pfg-price-max], [data-pfg-sort]')) {
        applyFilters(section, cards);
      }
    });

    var searchTimer;
    section.querySelector('[data-pfg-search]')?.addEventListener('input', function () {
      window.clearTimeout(searchTimer);
      searchTimer = window.setTimeout(function () { applyFilters(section, cards); }, 120);
    });

    section.querySelectorAll('[data-pfg-price-min], [data-pfg-price-max]').forEach(function (input) {
      input.addEventListener('input', function () {
        window.clearTimeout(searchTimer);
        searchTimer = window.setTimeout(function () { applyFilters(section, cards); }, 120);
      });
    });

    section.addEventListener('click', function (event) {
      var groupToggle = event.target.closest('[data-pfg-group-toggle]');
      if (groupToggle) {
        var panel = groupToggle.nextElementSibling;
        var expanded = groupToggle.getAttribute('aria-expanded') === 'true';
        groupToggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        panel?.classList.toggle('is-collapsed', expanded);
        return;
      }

      var preset = event.target.closest('[data-pfg-price-preset]');
      if (preset) {
        if (minInput) minInput.value = preset.dataset.min || '';
        if (maxInput) maxInput.value = preset.dataset.max || '';
        applyFilters(section, cards);
        return;
      }

      var chip = event.target.closest('[data-remove-filter-key]');
      if (chip) {
        var selector = '[data-pfg-checkbox][data-filter-key="' + CSS.escape(chip.dataset.removeFilterKey || '') + '"]';
        Array.from(section.querySelectorAll(selector)).forEach(function (input) {
          if (input.value === chip.dataset.removeFilterValue) input.checked = false;
        });
        applyFilters(section, cards);
        return;
      }

      if (event.target.closest('[data-remove-search]')) {
        var search = section.querySelector('[data-pfg-search]');
        if (search) search.value = '';
        applyFilters(section, cards);
        return;
      }

      if (event.target.closest('[data-remove-price]')) {
        if (minInput) minInput.value = '';
        if (maxInput) maxInput.value = '';
        applyFilters(section, cards);
        return;
      }

      if (event.target.closest('[data-pfg-search-clear]')) {
        var searchField = section.querySelector('[data-pfg-search]');
        if (searchField) {
          searchField.value = '';
          searchField.focus();
        }
        applyFilters(section, cards);
        return;
      }

      if (event.target.closest('[data-pfg-clear-all]')) {
        clearAll(section);
        applyFilters(section, cards);
        return;
      }

      if (event.target.closest('[data-pfg-filter-open]')) {
        setFiltersOpen(section, true);
        return;
      }

      if (event.target.closest('[data-pfg-filter-close], [data-pfg-overlay]')) {
        setFiltersOpen(section, false);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') setFiltersOpen(section, false);
    });

    window.addEventListener('resize', function () {
      if (!window.matchMedia('(max-width: 989px)').matches) {
        document.body.style.overflow = '';
        setFiltersOpen(section, false);
      }
    }, { passive: true });

    applyFilters(section, cards);
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-trendy-filter-grid-v2]').forEach(initGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
